import { z } from 'zod';

export const userSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  displayName: z.string().optional(),
  photoURL: z.string().url().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const businessIdeaSchema = z.object({
  id: z.string(),
  userId: z.string(),
  title: z.string().min(1, 'Title is required'),
  description: z.string().min(10, 'Description must be at least 10 characters'),
  problem: z.string().min(10, 'Problem statement must be at least 10 characters'),
  solution: z.string().min(10, 'Solution must be at least 10 characters'),
  targetMarket: z.string().min(5, 'Target market must be at least 5 characters'),
  uniqueValue: z.string().min(10, 'Unique value must be at least 10 characters'),
  revenueModel: z.string().min(5, 'Revenue model must be at least 5 characters'),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const leanCanvasSchema = z.object({
  id: z.string(),
  businessIdeaId: z.string(),
  problem: z.string().min(10),
  existingAlternatives: z.string().min(10),
  solution: z.string().min(10),
  keyMetrics: z.string().min(10),
  uniqueValueProposition: z.string().min(10),
  unfairAdvantage: z.string().min(10),
  channels: z.string().min(10),
  customerSegments: z.string().min(10),
  costStructure: z.string().min(10),
  revenueStreams: z.string().min(10),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const stepProgressSchema = z.object({
  stepType: z.enum(['idea-generation', 'business-planning', 'validation', 'marketing', 'payments']),
  isCompleted: z.boolean(),
  data: z.record(z.any()).optional(),
  completedAt: z.date().optional(),
});

export const userProgressSchema = z.object({
  userId: z.string(),
  businessIdeaId: z.string(),
  currentStep: z.enum([
    'idea-generation',
    'business-planning',
    'validation',
    'marketing',
    'payments',
  ]),
  steps: z.array(stepProgressSchema),
  createdAt: z.date(),
  updatedAt: z.date(),
});
